module.exports = __webpack_public_path__ + "img/review-waitting.5302d488.png";